/**
 * Request shape for an annotations.* dimension.
 *
 * Plain annotation fields go over the wire as the bare valuePath string. A
 * sub-theme drill option ("Camp & Program Delivery" picked from inside the
 * Thematics folder) additionally needs the taxonomy-scoped bucket restriction:
 * its document-level preset filter only narrows WHICH annotations count, so
 * without a bucket guest list every co-occurring tag on those annotations
 * ("Positive", "Joy", …) leaks in as a bar. `restrictBucketsByRollup` tells
 * the backend "only tags that roll up to this sub-theme may bucket" — resolved
 * there via the shared rollup map, so membership stays live as tags are added.
 *
 * A Topics option (dimensionType "topicClusteringNode") has no valuePath at
 * all and goes over as { dimensionType, level, parentTopicNodeId? } — the
 * last only on a topic drill, where it is the bucket restriction.
 *
 * Derived from what stored options ALREADY carry (value = the sub-theme id,
 * the preset filter's rollupPath, the isAnnoSubTheme stamp) — no new config
 * field, so widgets saved before this fix heal on their next load.
 */
export const annoDimForRequest = (dim) => {
  // Topics dimension (split mode): no valuePath — membership lives on the
  // clustering tree and the BE injects it per annotation. Only the level
  // travels; the lens resolves to the tenant's configured one BE-side.
  if (dim.dimensionType === "topicClusteringNode") {
    return {
      dimensionType: "topicClusteringNode",
      level: dim.level,
      // A topic drill: the BE restricts the bars to this topic's sub-topics.
      ...(dim.parentTopicNodeId ? { parentTopicNodeId: dim.parentTopicNodeId } : {}),
    };
  }
  const rollupPath = dim.presetActiveFilters?.[0]?.target?.rollupPath;
  if (dim.isAnnoSubTheme && dim.value && Array.isArray(rollupPath)) {
    return {
      valuePath: dim.valuePath,
      restrictBucketsByRollup: { path: rollupPath, values: [dim.value] },
    };
  }
  return dim.valuePath;
};
